import { RegionalModel } from './regional.model';

export class CooperativeModel {
  id: number;
  name: string;
  email: string;
  roles: string[];
  phone?: string;
  isActive: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  regional?: RegionalModel;

  // Roles específicos para cooperative
  static ROLES = {
    ROLE_COOPERATIVE: { CODE: 'ROLE_COOPERATIVE', DESC: 'Cooperative' },
  };
}
